import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import AppointmentDialog from "@/components/AppointmentDialog";

export default function CTABand({ title, subtitle }) {
  const [open, setOpen] = useState(false);
  return (
    <section className="bg-[#F5F7FA] py-20" data-testid="cta-band">
      <div className="mx-auto max-w-5xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-[#0B1F3A] rounded-3xl p-10 sm:p-14 relative overflow-hidden"
        >
          <div className="absolute -top-20 -right-20 h-64 w-64 rounded-full bg-[#00B8D9]/20 blur-3xl" />
          <div className="relative grid md:grid-cols-3 gap-6 items-center">
            <div className="md:col-span-2">
              <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">Diagnostic gratuit</div>
              <h3 className="font-heading font-black text-2xl sm:text-3xl lg:text-4xl text-white tracking-tight text-balance">
                {title || "Prêt à transformer votre PME en machine de croissance ?"}
              </h3>
              <p className="mt-3 text-gray-300">
                {subtitle || "30 min pour identifier vos opportunités numériques. Sans engagement."}
              </p>
            </div>
            <div className="flex justify-start md:justify-end">
              <Button onClick={() => setOpen(true)} data-testid="cta-band-button" className="bg-[#00B8D9] hover:bg-[#0096B3] text-white font-semibold px-7 py-6 text-base shadow-lg">
                Réserver un appel <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
      <AppointmentDialog open={open} onOpenChange={setOpen} defaultType="decouverte" />
    </section>
  );
}
